import {Component, forwardRef, Input, OnDestroy} from '@angular/core';
import {
  ControlValueAccessor, UntypedFormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
  Validator
} from '@angular/forms';
import {ReplaySubject} from 'rxjs';

@Component({
    selector: 'scitis-edit-column-input',
    templateUrl: './edit-column-input.component.html',
    styleUrls: ['./edit-column-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EditColumnInputComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => EditColumnInputComponent),
            multi: true
        }
    ],
    standalone: false
})
export class EditColumnInputComponent implements ControlValueAccessor, Validator, OnDestroy {

  @Input()
  show: boolean = false;
  @Input()
  value: string = '';
  @Input()
  items: any[] = [];
  @Input()
  placeholder: string = '';
  @Input()
  label: string = '';
  @Input()
  bindLabel: string = '';
  @Input()
  bindValue: string = '';
  @Input()
  errorRequiredMessage: string = 'Selection of default column type is required';
  @Input()
  disabled: boolean = false;
  @Input()
  isLoadingItems: boolean = false;
  @Input()
  last: boolean = false;
  @Input()
  translateItems: boolean = false;

  public control: UntypedFormControl = new UntypedFormControl();
  public onChange: (value: string) => void = () => {};
  public onTouched: () => void = () => {};

  private $destroy: ReplaySubject<boolean> = new ReplaySubject<boolean>();

  public get isValid(): boolean {
    return this.control &&
      !this.control.pending &&
      !this.control.errors &&
      !this.control.invalid;
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  validate(control: UntypedFormControl): ValidationErrors | null {
    this.control = control;
    return control.valid ? null : control.errors;
  }

  writeValue(value: string): void {
    if (this.value !== value) {
      this.value = value;
      this.onChange(value);
    }
  }

  ngOnDestroy(): void {
    this.$destroy.next(true);
    this.$destroy.complete();
  }
}
